<template>
    <tbody v-if="currentPageContacts" class="table-body">
        <tr class="table-body-row"
            v-for="(contact, index) in currentPageContacts"
            :key="index">
            <td class="table-body__checkbox">
                <CheckBox :checked="
                        isSelectedContact(contact.leadId)
                    "
                          @onClick="
                        handleContactSelection(
                            contact.leadId,
                            ...arguments,
                        )
                    "
                          :aria-label="`Select the contact for ${contact.firstName} ${contact.lastName}`" />
            </td>
            <td class="table-body__name"
                :title="
                truncateModalFields({
                fieldName: `${contact.firstName} ${contact.lastName}`,
                fieldLength: 24,
                attributeName: 'title',
                })
                ">
                {{
                        truncateModalFields({
                        fieldName: `${contact.firstName} ${contact.lastName}`,
                        fieldLength: 24,
                    })
                }}
            </td>
            <td class="table-body__email"
                data-test="email"
                :title="
                truncateModalFields({
                fieldName: `${contact.email}`,
                fieldLength: 24,
                attributeName: `title`,
                })
                ">
                {{
                    truncateModalFields({
                    fieldName: `${contact.email}`,
                    fieldLength: 24,
                   })
                }}
            </td>
        </tr>
    </tbody>
</template>

<script>
import CheckBox from '@/views/client-connect-v2/CheckBox.vue';
import { mapActions, mapState } from 'vuex';
    import { truncate } from 'lodash';
    import { truncateModalFields } from '@/views/client-connect-v2/helpers';

export default {
	name: 'RecipientTableBody',
	components: {
		CheckBox,
	},
    props: {
        currentPageContacts: Array,
        selectAllMode: Boolean,
    },
    computed: {
        ...mapState({
			leadIds: (state) => state.bbSelectRecipientModal.leadIds,
		}),
    },
	methods: {
        ...mapActions([
			'setLeadIds',
		]),
        truncate,
        truncateModalFields,
        isSelectedContact(leadId) {
            if (this.selectAllMode) {
                return !this.leadIds.includes(leadId);
            } else {
                return this.leadIds.includes(leadId);
            }
        },
        handleContactSelection(leadId, selected) {
			selected = this.selectAllMode ? !selected : selected;
			if (selected) {
				this.setLeadIds([...this.leadIds, leadId]);
			} else {
				this.setLeadIds(this.leadIds.filter((id) => id !== leadId));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
    .table-body-row {
        display: grid;
        grid-template-columns: 4% 40% 52%;
        gap: 2%;
        align-items: center;
        @include rem('padding', 12px);
        border-top: 1px solid $border-color-light;

    }

    .table-body-row {
        @include rem('font-size', 16px);
    }

    @media only screen and (max-width: 600px) {
        .table-body-row {
            gap: 4%;
            grid-template-columns: 5% auto;
        }

        .table-body__email {
            display: none;
        }
    }
</style>
